export default {
    props: {
        serializationCustom: {
            type: Function,
            default: undefined,
            kComposite: 'serialization.custom'
        }, 
        serializationEntities: {
            type: Boolean,
            default: undefined,
            kComposite: 'serialization.entities'
        }, 
        serializationScripts: {
            type: Boolean,
            default: undefined,
            kComposite: 'serialization.scripts'
        }, 
        serializationSemantic: {
            type: Boolean,
            default: undefined,
            kComposite: 'serialization.semantic'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/Serialization.js